<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("adicionar-forma-recebimento") }}
                        </h1>
                    </div>

                    <!-- BOTÃO DE SALVAR -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="onFecharModal"
                        >
                            {{ $t("cancelar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="formaRecebimento.idformarecebimentoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="
                                    !formaRecebimento.idformarecebimentoerp
                                "
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                ref="nomeInput"
                                v-model="formaRecebimento.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!formaRecebimento.descricao"
                                required
                                uppercase
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="formaRecebimento.id == null"
                                title="situacao"
                                tooltipLabel="info-situacao-generica"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//SERVICES
import FormaRecebimentoService from "@/services/FormaRecebimentoService";
import AssFormaRecebimentoClienteService from "@/services/vendas/cliente/abas/AssFormaRecebimentoClienteService";
import FormaRecebimentoValidation from "@/services/validations/vendas/FormaRecebimentoValidation";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";

export default {
    components: {
        HideInfo,
    },
    props: {
        idCliente: 0,
        permissaoVincular: false,
    },
    data() {
        return {
            service: new FormaRecebimentoService(this.$http, this.$router),
            serviceAss: new AssFormaRecebimentoClienteService(
                this.$http,
                this.$routers
            ),
            validation: new FormaRecebimentoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            formaRecebimento: {
                id: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            situacao: { label: "ativo", id: 1 },

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "vendas",
            "ven-forma-recebimento"
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "forma-recebimento" },
            });
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.formaRecebimento = value.content;
                    this.situacao =
                        this.situacoes[this.formaRecebimento.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },

        save() {
            this.isLoading = true;

            if (this.validation.validate(this.formaRecebimento, this.$refs)) {
                let formaRecebimentoTemp = Object.assign(
                    {},
                    this.formaRecebimento
                );
                formaRecebimentoTemp = this.mapTosave(formaRecebimentoTemp);
                formaRecebimentoTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(formaRecebimentoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-save-forma-recebimento";
                            if (
                                this.formaRecebimento.idformarecebimento != null
                            ) {
                                msg = "msg-edit-forma-recebimento";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            if (this.permissaoVincular) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.$emit("fecharModal");
                            }
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(new Message(
                                    'alert', 
                                    this.$t(message, { n: formaRecebimentoTemp.idformarecebimentoerp }), 
                                    true, 
                                    false
                                ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "ven-forma-recebimento",
                });
            }, 1000);
        },
        promptConfirmaVinculo(forma) {
            this.$root.confirm({
                message: this.$t("deseja-realizar-vinculo"),
                onConfirm: (_) => {
                    this.realizarVinculo(forma);
                },
                onCancel: (_) => {
                    this.$emit("fecharModal");
                },
            });
        },
        realizarVinculo(forma) {
            let assTemp = [
                {
                    idformarecebimento: forma.idformarecebimento,
                    idcliente: this.idCliente,
                },
            ];
            this.saveFR(assTemp)
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(
                            new Message("error", `${value.message}`, true)
                        );
                    } else {
                        this.$emit("cadastrado");
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveFR(assTemp) {
            if(this.isVenda) return this.serviceAss.saveVendas(assTemp);
            else return this.serviceAss.saveAgro(assTemp);
        },
        onFecharModal() {
            this.$emit("fecharModal", true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
